import {
  Box,
  Container,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";


import Logo from "../assests/vedicwin.webp";

const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/vedicwin/",
    icon: <InstagramIcon sx={{ fontSize: 26 }} />,
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61592647318559",
    icon: <FacebookRoundedIcon sx={{ fontSize: 26 }} />,
  },
];

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: "#102B6B", color: "#fff" }}>
      <Container
        maxWidth="xl"
        sx={{
          py: { md: 2 },
          px: { md: 6 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent:"space-between",
            gap: { xs: 4, md: 6 },
            alignItems: "center",
          }}
        >
          {/* Logo Section */}
          <Box>
            <Box
              component="img"
              src={Logo}
              alt="VedicWin Logo"
              sx={{
                width: 120,
                height: "auto",
                mb: 1,
              }}
            />

            <Typography
              variant="body2"
              sx={{
                maxWidth: 320,
                fontSize: "0.9rem",
                color: "rgba(255,255,255,0.75)",
                lineHeight: 1.8,
              }}
            >
              Building bright futures with focused learning and thoughtful
              guidance.
            </Typography>
          </Box>

          {/* Contact Section */}
          {/* Address Section */}
          <Box>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                fontSize: "1.1rem",
                mb: 1.5,
              }}
            >
              Address:
            </Typography>

            <Stack direction="row" spacing={1.5} alignItems="flex-start">
          
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.9rem",
                  color: "rgba(255,255,255,0.75)",
                  lineHeight: 1.7,
                }}
              >
                14-1-211/434, Parvath Nagar,
                <br />
                Near HITEC City,
                <br />
                Hyderabad, Telangana - 500018.
              </Typography>
            </Stack>
          </Box>

          {/* Follow Us */}
        <Box
  sx={{
    display: "flex",
    flexDirection: "column",
      
  }}
>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                fontSize: "1.1rem",
                mb: 1.5,
              }}
            >
              Follow Us
            </Typography>

            <Stack direction="row" spacing={1.2} alignItems="center">
              {socialLinks.map(({ label, href, icon }) => (
                <IconButton
                  key={label}
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  sx={{
                    width: 48,
                    height: 48,
                    color: "#fff",
                    border: "2px solid rgba(255,255,255,0.4)",
                    transition: "all .3s ease",

                    "&:hover": {
                      bgcolor: "#FF6B00",
                      borderColor: "#FF6B00",
                      transform: "translateY(-3px)",
                    },
                  }}
                >
                  {icon}
                </IconButton>
              ))}
            </Stack>
          </Box>
        </Box>

        <Divider
          sx={{
            my: 3,
            borderColor: "rgba(255,255,255,0.15)",
          }}
        />

       <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }}
>
  <Typography
    variant="body2"
    sx={{
      fontSize: "0.85rem",
      color: "rgba(255,255,255,0.65)",
      textAlign: "center",
    }}
  >
    © {new Date().getFullYear()} VedicWin Tuition Center. All rights reserved.
  </Typography>
</Box>
      </Container>
    </Box>
  );
}
